module.exports = __webpack_public_path__ + "static/media/icon-social.8bcc9be9.svg";